@if (loadingSupplier()) {
  <div class="flex items-center justify-center py-12">
    <p class="text-neutral-text text-[14px]" i18n="@@adminEditSupplierLoading">Loading supplier...</p>
  </div>
} @else {
  <form [formGroup]="supplierForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
    <div class="flex flex-col gap-6 rounded-2xl bg-white p-6 shadow-sm">
      <h3 class="text-primary text-[20px] font-[600]" i18n="@@adminAddSupplierTitle">Supplier Information</h3>

      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-[500]" i18n="@@adminProductFormTitleEnLabel">
            Title (En)
          </label>
          <input
            type="text"
            formControlName="titleEn"
            placeholder="Enter supplier title in English (optional)"
            i18n-placeholder="@@adminSupplierFormTitleEnPlaceholder"
            class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
            [class.border-red-500]="supplierForm.get('titleEn')?.invalid && supplierForm.get('titleEn')?.touched" />
          @if (supplierForm.get("titleEn")?.invalid && supplierForm.get("titleEn")?.touched) {
            <span class="text-danger-text text-[12px]">
              @if (
                supplierForm.get("titleEn")?.errors?.["minlength"] || supplierForm.get("titleEn")?.errors?.["maxlength"]
              ) {
                <span i18n="@@adminSupplierFormErrorTitleEnLength">Title must be between 2 and 100 characters</span>
              }
            </span>
          }
        </div>

        <div class="flex flex-col gap-2" dir="rtl">
          <label class="text-[14px] font-[500]">
          <span i18n="@@adminProductFormTitleArLabel">Title (Ar)</span>
          <span class="text-danger-text">*</span>
        </label>
          <input
            type="text"
            formControlName="titleAr"
            placeholder="Enter supplier title in Arabic"
            i18n-placeholder="@@adminSupplierFormTitleArPlaceholder"
            class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none" />
          @if (supplierForm.get("titleAr")?.invalid && supplierForm.get("titleAr")?.touched) {
            <span class="text-danger-text text-[12px]">
              @if (supplierForm.get("titleAr")?.errors?.["required"]) {
                <span i18n="@@adminSupplierFormErrorTitleArRequired">Arabic title is required</span>
              } @else if (supplierForm.get("titleAr")?.errors?.["minlength"] || supplierForm.get("titleAr")?.errors?.["maxlength"]) {
                <span i18n="@@adminSupplierFormErrorTitleArRange">Arabic title must be between 2 and 100 characters</span>
              } @else if (supplierForm.get("titleAr")?.errors?.["notArabic"] || supplierForm.get("titleAr")?.errors?.["hasNumbers"]) {
                <span i18n="@@adminSupplierFormErrorTitleArCharacters">Arabic title must contain Arabic letters only</span>
              } @else if (supplierForm.get("titleAr")?.errors?.["leadingTrailingSpaces"]) {
                <span i18n="@@adminSupplierFormErrorTitleArSpaces">Arabic title cannot start or end with spaces</span>
              }
            </span>
          }
        </div>
      </div>
    </div>

    @if (errorUpdatingSupplier()) {
      <div class="rounded-[6px] border border-red-200 bg-red-50 px-4 py-3">
        <p class="text-[14px] text-red-800">{{ errorUpdatingSupplier() }}</p>
      </div>
    }

    <div class="flex justify-end gap-3">
      <button
        type="button"
        (click)="onCancel()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@cancel">Cancel</span>
      </button>
      <button
        type="submit"
        [disabled]="loading()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer disabled:opacity-50">
        @if (loading()) {
          <span i18n="@@loading">Saving...</span>
        } @else {
          <span i18n="@@save">Save</span>
        }
      </button>
    </div>
  </form>
}
